export function getReturnOfExpression(expression) {
    return null;
}
export var returntypeof = getReturnOfExpression;
//# sourceMappingURL=type-utils.js.map